import { Logger, sharedRef } from '@vue-storefront/core';
import { computed } from '@nuxtjs/composition-api';
import { errorToString } from '~/helpers/error/errorToString';
import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';
import { Cart, Order } from '~/types/commercetools';

export function useMakeOrder() {
  const order = sharedRef<Order | null>(null, 'useMakeOrder-order');
  const loading = sharedRef(false, 'useMakeOrder-loading');
  const error = sharedRef({ make: '' }, 'useMakeOrder-error');

  type OrderResponse = {
    order: Order;
  }
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  async function make({ id, version, customQuery }:
    { id: Cart['id'], version: Cart['version'], customQuery?: string }) {
    try {
      loading.value = true;
      const createOrderResponse = await makeCommercetoolsRequest<OrderResponse>({
        endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.CREATE_MY_ORDER_FROM_CART,
        data: {
          id,
          version,
          customQuery,
        },
      });
      order.value = createOrderResponse?.data?.order ?? null;
      error.value.make = '';
    } catch (err) {
      error.value.make = errorToString(err);
      Logger.error('useMakeOrder.createMyOrderFromCart', err);
    } finally {
      loading.value = false;
    }
  }

  return {
    order: computed(() => order.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    make,
  };
}
